export default function useDataConfiguration(props) {
  return {
    variables: { event_id: props.event_id },
  }
}
